import { Box, Grid, Typography } from '@mui/material'

import React from 'react'
import { useNavigate } from 'react-router-dom'
export default function SelectedTestPerformanceDetails() {
     const navigate =useNavigate()
  return (
  <Grid container spacing={2}>

        <Grid
        item xs={12}
            container
            gap={2}
            alignItems="center"
            onClick={() => navigate("/test-prep/classroom")}
            sx={{ cursor: "pointer" }}
          >
            <Box width={32}>
              <img src="/newdashboard/Classrom/wishlist.png" />
            </Box>
            <Typography
              textAlign="start"
              color="#572575"
              fontFamily="Inter"
              fontSize="24px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
          My Performance 
            </Typography>
          </Grid>
    
  </Grid>
  )
}
